import { faBriefcase, faDollarSign, faEllipsisVertical, faUser, faUserLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react'
import { Col, Dropdown, Nav, Row, Tab } from 'react-bootstrap';
import { UnauthorizedTableState } from '../../../../CommonComponents/UnauthorizedTableState';
import { formatDate, formatToINR, navigateToCrmDetail, putCommaInLeadsValue, usePermissions } from '../../../../Utils/helpers/commonhelper';
import { DescriptionTooltip } from '../../../../Utils/helpers/descriptionTooltip/DescriptionTooltip';
import nodata from "../../../../Utils/assets/img/leads_no_data_found.png"
import { CreateDeal } from '../../../deals/CreateDeal';
import { CreateLead } from '../../../Leads/CreateLead';
import { UpdateDeal } from '../../../deals/UpdateDeal';
import DeleteModal from '../../../DeleteModal';
import useLocalStorageState from 'use-local-storage-state';
import { toast } from 'sonner';
import { DeleteRequest, GetRequest } from '../../../../Utils/hooks/ApiHandler';
import { useNavigate, useLocation } from 'react-router-dom';
import { ProspectsTable } from '../../../../CommonComponents/ProspectsTable';
import { useGetEssentials } from '../../../../Utils/hooks/useGetEssentials';


export const ContactProspectsInfo = ({ contactId, contactLeads, fetchContactDetails, contactDetails }) => {
    const { customer, headers, extras, customerId } = useGetEssentials()
    const navigate = useNavigate()
    const location = useLocation()
    // permission setup for conntacts
    const [PERMISSION] = useLocalStorageState('permission')
    // permission for lead and deal
    const leadGrant = PERMISSION?.leads;
    const dealGrant = PERMISSION?.deals;

    const [loading, setLoading] = useState(false)
    const [statusLoading, setStatusLoading] = useState(false)

    const [currModule, setCurrModule] = useState('leads');

    // show deal offcanvas
    const [showAddDealOffcanvas, setShowAddDealOffcanvas] = useState(false);
    // update or edit deal offcanvas state
    const [showUpdateDealOffcanvas, setShowUpdateDealOffcanvas] = useState(false)
    // lead and deal id for edit and delete use
    const [editLeadId, setEditLeadId] = useState(null)
    const [editDealId, setEditDealId] = useState(null)
    // deal data set
    const [deals, setDeals] = useState(null)
    // const [contactDeals, setContactDeals] = useState([])
    // leads and deals status
    const [dealStatus, setDealStatus] = useState('all')
    const [leadsStatus, setLeadsStatus] = useState('all');
    const [leads, setLeads] = useState(null);
    // set deals card data
    const [dealsCardData, setDealsCardData] = useState([])
    // delete dealId
    const [showDealDeleteModal, setShowDealDeleteModal] = useState(false)
    // delete leadId
    const [showLeadDeleteModal, setShowLeadDeleteModal] = useState(false)
    // open delete modal to delete lead
    const [deleteLeadId, setDeleteLeadId] = useState(null)
    //open delete mode to delete deal
    const [deleteDealId, setDeleteDealId] = useState(null)

    // ProspectsTable still sets pipeline id on row click; detail identity now goes via navigate state
    const [, setSelectedPipelineId] = useState(null)

    // open lead offcanvas
    const [showAddLeadsOffcanvas, setShowAddLeadsOffcanvas] = useState(false);

    // associated leads and deals state
    const [associatedDeals, setAssociatedDeals] = useState(false);


    const fetchAllDeals = async () => {
        try {
            setStatusLoading(true)
            const res = await GetRequest(
                `contacts/fetchContactAllDeals/${contactId}/${customerId}`,
                { headers },
                extras
            );
            if (res.status === 'fail' || res.success === false) {
                setDeals(null)
                return
            }
            // setContactDeals(res.data.allDeals);
            setDealsCardData(res.data)
            setDeals(res.data?.allDeals)
        } catch (error) {
            return
        }
    };

    const fetchAllLeads = async () => {
        try {
            setStatusLoading(true)
            const res = await GetRequest(
                `contacts/getAllAssociatedLeadsOfContact/${contactId}/${customerId}`,
                { headers },
                extras
            );
            if (res.status === 'fail' || res.success === false) {
                setLeads(null)
                return
            }
            setLeads(res.data)
        } catch (error) {
            return
        }
    };

    const fetchLeads_status = async () => {
        try {
            if (leadsStatus === 'all') {
                fetchAllLeads()
                return;
            }

            const endpoint =
                leadsStatus === "won"
                    ? `contacts/fetchWonLeads/${customerId}/${contactId}`
                    : leadsStatus === "lost"
                        ? `contacts/fetchLostLeads/${customerId}/${contactId}`
                        : `contacts/fetchUnqualifiedLeads/${customerId}/${contactId}`;
            setStatusLoading(true);
            const res = await GetRequest(endpoint, { headers }, extras);
            setLeads(res.data);
        } catch (err) {
            return
        } finally {
            setStatusLoading(false);
        }
    };

    useEffect(() => {
        if (!associatedDeals) {
            fetchLeads_status();
        }
    }, [leadsStatus, associatedDeals, contactDetails]);

    const fetchDealsByStatus = async () => {
        try {
            if (dealStatus === 'all') {
                await fetchAllDeals();
                return;
            }

            const endpoint =
                dealStatus === "won"
                    ? `contacts/getDealsBasedOnStatus/${contactId}/${customerId}/won`
                    : dealStatus === "lost"
                        ? `contacts/getDealsBasedOnStatus/${contactId}/${customerId}/lost`
                        : `contacts/getDealsBasedOnStatus/${contactId}/${customerId}/unqualified`;
            setStatusLoading(true)
            const res = await GetRequest(endpoint,
                { headers },
                extras
            )
            setDeals(res?.data)
        } catch (error) {
            console.error(error)
        } finally {
            setStatusLoading(false)
        }
    }

    useEffect(() => {
        if (associatedDeals) {
            fetchDealsByStatus();
        }
    }, [dealStatus, associatedDeals]);



    const onLeadDelete = (id) => {
        if (!leadGrant?.isDelete) {
            toast.warning("You are not authorized for this action!")
            return
        }
        setDeleteLeadId(id)
        setShowLeadDeleteModal(true);
    }


    // function to close edit deals canvas
    const handleUpdateDealClose = () => {
        setCurrModule(null)
        setShowUpdateDealOffcanvas(false)
    }

    const handleLeadDetailPage = (val) => {
        setCurrModule('leads')
        navigateToCrmDetail(navigate, location, "/leadDetails", {
            id: val?.id,
            pipeline_id: val?.pipeline_id,
        })
    };

    const handleDealDetailPage = (val) => {
        setCurrModule('deals')
        navigateToCrmDetail(navigate, location, "/dealDetails", {
            id: val?.id,
            pipeline_id: val?.pipeline_id,
        })
    };

    // function to delete leads
    const handleDeleteConfirm = async () => {
        setLoading(true)
        try {
            const response = await DeleteRequest(`lead/deleteLead/${deleteLeadId}/${customer?.customer_details?.id}`,
                { headers },
                extras)

            if (response?.status === "success") {
                toast.success("Lead deleted successfully")
                setLoading(false)
                await fetchContactDetails();
            } else {
                setLoading(false)
                toast.error(response?.message || "Failed to delete lead")
            }
        } catch (error) {
            setLoading(false)
            toast.error("An error occurred while deleting lead")
        } finally {
            setLoading(false)
            setShowLeadDeleteModal(false)
            setDeleteLeadId(null)
        }
    }

    // function to delete deal
    const handleDeleteDealConfirm = async () => {
        setLoading(true)
        try {
            const response = await DeleteRequest(`deals/deleteDeal/${deleteDealId}/${customer.customer_details?.id}`,
                { headers }, extras
            )
            if (response.success === false) {
                setLoading(false)
                return
            }
            if (response.status === 'fail') {
                setLoading(false)
                console.log('hithere')
                toast.warning(response?.message)
                return
            }

            setLoading(false)
            toast.success(response.message)
            await fetchAllDeals()

        } catch (error) {
            setLoading(false)
            toast.error("An error occurred while deleting deal")
        } finally {
            setLoading(false)
            setShowDealDeleteModal(false)
            setDeleteDealId(null)
        }
    }

    return (
        <>
            <Row
                className="w-100 ms-0 mt-2 ps-0 pe-2"
                style={{ minHeight: "390px" }}
            >
                <Col
                    md={12}
                    className="tab-container bg-white ps-0 pe-0"
                    style={styles.tabContainer}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex gap-1 align-items-center mx-3">
                            <h4
                                style={{
                                    fontSize: associatedDeals ? 15 : 20,
                                    fontWeight: 300,
                                    color: associatedDeals ? "gray" : "black",
                                    cursor: "pointer",
                                }}
                                className="my-3 "
                                onClick={() => {
                                    setLeadsStatus('all');
                                    setCurrModule('leads')
                                    setAssociatedDeals(false);
                                }}
                            >
                                Associated Leads
                            </h4>
                            <span>|</span>
                            <h4
                                style={{
                                    fontSize: associatedDeals ? 20 : 15,
                                    fontWeight: 300,
                                    color: associatedDeals ? "black" : "gray",
                                    cursor: "pointer",
                                }}
                                className="my-3 "
                                onClick={() => {
                                    setAssociatedDeals(true);
                                    setCurrModule('deals')
                                    setDealStatus('all');
                                }}
                            >
                                Associated Deals
                            </h4>
                        </div>
                        {/* //leads div for add and listing leads */}
                        {!associatedDeals && (
                            <div
                                className="d-flex align-items-center gap-2 pe-3"
                            //  style={{display:associatedDeals ? "none" : "block"}}
                            >
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: 'rgb(63, 151, 253)'
                                    }}
                                    onClick={() => {
                                        if (!leadGrant.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        setShowAddLeadsOffcanvas(true);
                                    }}
                                >
                                    Add Lead
                                </p>
                                <p
                                    className="mb-0 mx-2 "
                                    style={{
                                        borderRight: "1px solid #c9c9c9",
                                        height: 19,
                                    }}
                                ></p>
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: "rgb(63, 151, 253)"
                                    }}
                                    onClick={() => {
                                        if (!leadGrant.isView) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        window.open(
                                            `${window.location.origin}/leads?module=contact&id=${contactId}`,
                                            "_blank"
                                        )
                                    }
                                    }
                                >
                                    List All Leads
                                </p>
                            </div>
                        )}

                        {/* // deals div for add and listing deals */}
                        {associatedDeals && (
                            <div
                                className="d-flex align-items-center gap-2 pe-3"
                            // style={{display:associatedDeals?"block" : "none"}}
                            >
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: "rgb(63, 151, 253)"
                                    }}
                                    onClick={() => {
                                        if (!dealGrant.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        };
                                        setShowAddDealOffcanvas(true)
                                    }}
                                >
                                    Add Deal
                                </p>
                                <p
                                    className="mb-0 mx-2 "
                                    style={{
                                        borderRight: "1px solid #c9c9c9",
                                        height: 19,
                                    }}
                                ></p>
                                <p
                                    className="mb-0"
                                    style={{
                                        fontSize: 12,
                                        fontWeight: 400,
                                        cursor: "pointer",
                                        color: "rgb(63, 151, 253)",
                                    }}
                                    onClick={() => {
                                        if (!dealGrant.isView) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                        }
                                        window.open(
                                            `${window.location.origin}/deals?module=contact&id=${contactId}`,
                                            "_blank"
                                        )
                                    }}
                                >
                                    List All Deals
                                </p>
                            </div>
                        )}
                    </div>
                    {associatedDeals ? (
                        // deals tab container
                        <Tab.Container>
                            <Nav
                                variant="pills"
                                className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                            >
                                {/* all deals */}
                                <Nav.Item
                                    className="me-0"
                                    style={{ minWidth: "17%" }}
                                    onClick={() => {
                                        setDealStatus('all');
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.navLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            All Deals{" "}
                                            <FontAwesomeIcon icon={faDollarSign} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.AllCount || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        dealsCardData?.total_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* won deals */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%", cursor: dealsCardData?.won === 0 ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => {
                                        if (dealsCardData?.won === 0) {
                                            return;
                                        } else {
                                            // setContactDeals([])
                                            setDealStatus("won");
                                            fetchDealsByStatus();
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Won Deals{" "}
                                            <FontAwesomeIcon icon={faBriefcase} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.won || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p
                                                    style={{
                                                        color: "white",
                                                        fontWeight: 400,
                                                    }}
                                                >

                                                    {formatToINR(
                                                        dealsCardData?.won_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* lost deals */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%", cursor: dealsCardData?.lost === 0 ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => {
                                        if (dealsCardData?.lost === 0) {
                                            return;
                                        } else {
                                            // setContactDeals([])
                                            setDealStatus("lost");
                                            fetchDealsByStatus();
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Lost Deals <FontAwesomeIcon icon={faUser} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.lost || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        dealsCardData?.lost_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* unqualified */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%", cursor: dealsCardData?.unqualified === 0 ? "not-allowed" : "pointer"
                                    }}
                                    onClick={() => {
                                        if (dealsCardData?.unqualified === 0) {
                                            return;
                                        } else {
                                            // setContactDeals([])
                                            setDealStatus("unqualified");
                                            fetchDealsByStatus()
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Unqualified Deals{" "}
                                            <FontAwesomeIcon icon={faUserLock} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{ fontSize: "25px", fontWeight: 300 }}
                                        >
                                            {putCommaInLeadsValue(
                                                dealsCardData?.unqualified || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0 text-white"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        dealsCardData?.unqualified_revenue || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>

                            {/* deals table mapping */}
                            <ProspectsTable
                                type={"deals"}
                                data={deals}
                                permissionGrant={dealGrant}
                                currentNavCard={dealStatus}
                                openDetailPage={handleDealDetailPage}
                                setSelectedPipelineId={setSelectedPipelineId}
                                isLoading={statusLoading}
                            />
                        </Tab.Container>
                    ) : (
                        // leads tab container
                        <Tab.Container>
                            <Nav
                                variant="pills"
                                className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                            >
                                {/* all leads */}
                                <Nav.Item
                                    className="me-0"
                                    style={{ minWidth: "17%" }}
                                    onClick={() => {
                                        setLeadsStatus('all');
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.navLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white" >
                                            All Leads{" "}
                                            <FontAwesomeIcon icon={faDollarSign} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.leads?.length || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue || "0"
                                                    )
                                                    }
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* won leads */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%",
                                        cursor:
                                            contactDetails?.total_won_leads === 0
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={() => {
                                        if (
                                            contactDetails?.total_won_leads === 0
                                        ) {
                                            return;
                                        } else {
                                            setLeadsStatus("won");
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Won Leads{" "}
                                            <FontAwesomeIcon icon={faBriefcase} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.total_won_leads || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue_won || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* lost leads */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%",
                                        cursor:
                                            contactDetails?.total_lost_leads === 0
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={() => {
                                        if (
                                            contactDetails?.total_lost_leads === 0
                                        ) {
                                            return;
                                        } else {
                                            setLeadsStatus("lost");
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Lost Leads <FontAwesomeIcon icon={faUser} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.total_lost_leads || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue_lost || "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                                {/* unqualified */}
                                <Nav.Item
                                    className="me-0"
                                    style={{
                                        minWidth: "17%",
                                        cursor:
                                            contactDetails?.total_unqualified_leads === 0
                                                ? "not-allowed"
                                                : "pointer",
                                    }}
                                    onClick={() => {
                                        if (
                                            contactDetails?.total_unqualified_leads === 0
                                        ) {
                                            return;
                                        } else {
                                            setLeadsStatus("unqualified");
                                        }
                                    }}
                                >
                                    <Nav.Link
                                        style={styles.inActiveNavLinksStyle}
                                    >
                                        <p className="d-flex justify-content-between mb-1 text-white">
                                            Unqualified Leads{" "}
                                            <FontAwesomeIcon icon={faUserLock} />
                                        </p>
                                        <p
                                            className="mb-0 mt-2 d-flex justify-content-between text-white"
                                            style={{
                                                fontSize: "25px",
                                                fontWeight: 300,
                                            }}
                                        >
                                            {putCommaInLeadsValue(
                                                contactDetails?.total_unqualified_leads || 0
                                            )}
                                            <span
                                                style={{
                                                    fontSize: "12px",
                                                    fontWeight: 400,
                                                    textAlign: "end",
                                                    color: 'white'
                                                }}
                                            >
                                                <p
                                                    className="mb-0"
                                                    style={{
                                                        fontWeight: 200,
                                                        fontSize: 10,
                                                        color: "white",
                                                    }}
                                                >
                                                    Approx Value INR
                                                </p>
                                                <p style={{ color: "white", fontWeight: 400 }}>
                                                    {formatToINR(
                                                        contactLeads?.total_revenue_unqualified ||
                                                        "0"
                                                    )}
                                                </p>
                                            </span>
                                        </p>
                                    </Nav.Link>
                                </Nav.Item>
                            </Nav>
                            <ProspectsTable
                                type={"leads"}
                                data={leads}
                                permissionGrant={leadGrant}
                                currentNavCard={leadsStatus}
                                openDetailPage={handleLeadDetailPage}
                                setSelectedPipelineId={setSelectedPipelineId}
                                isLoading={statusLoading}
                            />
                        </Tab.Container>
                    )}
                </Col>

                {showAddDealOffcanvas && (
                    <CreateDeal
                        show={showAddDealOffcanvas}
                        onHide={() => {
                            setShowAddDealOffcanvas(false);
                            setCurrModule(null)
                        }}
                        refetchDeals={fetchAllDeals}
                        moduleName="contact"
                        id={contactId}
                        setDealAdd={setDeals}
                    />
                )}

                {/* edit deal */}
                <UpdateDeal
                    show={showUpdateDealOffcanvas}
                    setShow={setShowUpdateDealOffcanvas}
                    onHide={handleUpdateDealClose}
                    editId={editDealId}
                    onLeadUpdated={fetchAllDeals}
                />

                {/* delete leads */}
                {showLeadDeleteModal &&
                    <DeleteModal
                        show={setShowLeadDeleteModal}
                        onClose={() => {
                            setShowLeadDeleteModal(false);
                            setDeleteLeadId(null)
                        }}
                        onConfirm={handleDeleteConfirm}
                        isLoading={loading}
                        message="Are you sure you want to delete this lead?"
                    />
                }

                {/* delete deals */}
                {showDealDeleteModal &&
                    <DeleteModal
                        show={showDealDeleteModal}
                        onClose={() => {
                            setDeleteDealId(null)
                            setShowDealDeleteModal(false)
                        }}
                        isLoading={loading}
                        onConfirm={handleDeleteDealConfirm}
                        message="Are you sure you want to delete this deal?"
                    />
                }

                {showAddLeadsOffcanvas && (
                    <CreateLead
                        show={showAddLeadsOffcanvas}
                        onHide={() => {
                            setEditLeadId(null)
                            setCurrModule(null)
                            setShowAddLeadsOffcanvas(false)
                        }}
                        refetchLeads={fetchAllLeads}
                        module_name="contact"
                        contactId={contactId}
                        editId={editLeadId}
                    />
                )}
            </Row>
        </>
    )
}

//             {/* // show add deal offcanvas */}
//             {
//                 <CreateDeal
//                     show={showAddDealOffcanvas}
//                     onHide={() => {
//                         setShowAddDealOffcanvas(false);
//                     }}
//                     refetchDeals={fetchAllDeals}
//                     moduleName="contact"
//                     id={contactId}
//                     setDealAdd={setDeals}
//                 />
//             }

//             {/* edit deal */}
//             <UpdateDeal
//                 show={showUpdateDealOffcanvas}
//                 setShow={setShowUpdateDealOffcanvas}
//                 onHide={handleUpdateDealClose}
//                 editId={editDealId}
//                 onLeadUpdated={fetchAllDeals}
//             />


//             {/* delete leads */}
//             {showLeadDeleteModal &&
//                 <DeleteModal
//                     show={setShowLeadDeleteModal}
//                     onClose={() => {
//                         setShowLeadDeleteModal(false);
//                         setDeleteLeadId(null)
//                     }}
//                     onConfirm={handleDeleteConfirm}
//                     isLoading={loading}
//                     message="Are you sure you want to delete this lead?"
//                 />
//             }

//             {/* delete deals */}
//             {showDealDeleteModal &&
//                 <DeleteModal
//                     show={showDealDeleteModal}
//                     onClose={() => {
//                         setDeleteDealId(null);
//                         setShowDealDeleteModal(false)
//                     }}
//                     onConfirm={handleDeleteDealConfirm}
//                     isLoading={loading}
//                     message="Are you sure you want to delete this lead?"
//                 />
//             }

//             {
//                 showDealDetails && (
//                     <DealDetails
//                         show={showDealDetails}
//                         onClose={handleClose}
//                         dealId={selectedDealId}
//                         pipelineStageData={pipelineStages}
//                         canEdit_canDownload={canEdit_canDownload}
//                         setSelectedStageId={setSelectedStageId}

//                     />
//                 )
//             }
//             {
//                 showLeadDetails && pipelineStages !== null && (
//                     <LeadsDetails
//                         leadId={selectedLeadId}
//                         show={showLeadDetails}
//                         onClose={handleClose}
//                         pipelineStageData={pipelineStages}
//                         canEdit_canDownload={canEdit_canDownload}
//                         onDelete={onLeadDelete}
//                     />
//                 )

//             }
//         </>
//     )
// }

const styles = {
    navLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
    },
    inActiveNavLinksStyle: {
        borderRadius: "0px",
        borderBottom: "1px solid #E0E4F8",
        borderRight: "1px solid #E0E4F8",
        fontSize: 14,
        padding: "11px",
        fontFamily: '"Inter", sans-serif !important',
        fontWeight: 400,
        lineHeight: 1.5,
        pointerEvents: "none",
    },
    tabContainer: {
        border: "1px solid #E0E4F8",
        borderRadius: "4px",
    },
};